import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    purchaseInvoices: [],
    purchaseInvoice: null,
    filteredPurchaseInvoices: [],
    isLoading: false,
    isUpdating: false,
    isUpdated: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function purchaseInvoiceReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
        case Constants.REQUEST_GET_PURCHASE_INVOICE:
            newState = {
                ...state,
                isLoading: true,
                isPosting: false,
                isPosted: false,
                error: null
            };

            return newState;
        case Constants.REQUEST_ADD_PURCHASE_INVOICE:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;
        case Constants.SUCCESS_ADD_PURCHASE_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            newState.purchaseInvoice = action.purchaseInvoice;
            return newState;
        // case Constants.SUCCESS_FILTERED_PURCHASE_INVOICE:
        //     newState = { ...state };
        //     newState.isPosting = false;
        //     newState.isLoading = false;
        //     newState.error = null;
        //     newState.isPosted = false;
        //     newState.filteredPurchaseInvoices = action.filteredPurchaseInvoices;
        //     return newState;
        case Constants.FAILED_ADD_PURCHASE_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        // case Constants.REQUEST_UPDATE_PURCHASE_INVOICE:
        //     newState = {
        //         ...state,
        //         isUpdating: true
        //     }
        //     return newState;
        // case Constants.SUCCESS_UPDATE_PURCHASE_INVOICE:
        //     newState = { ...state };
        //     newState.isUpdating = false;
        //     newState.isUpdated = true;
        //     if (action.id) newState.purchaseInvoices = state.purchaseInvoices.filter(a => a.id !== action.id);
        //     return newState;
        //
        // case Constants.FAILED_UPDATE_PURCHASE_INVOICE:
        //     newState = {
        //         ...state,
        //         isUpdating: false,
        //         error: action.error
        //     }
        //     return newState;
        //
        case Constants.SUCCESS_GET_PURCHASE_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            if (action.payload.items) {
                newState.purchaseInvoices = action.payload.items;
                newState.page = action.payload.page;
                newState.pageSize = action.payload.pageSize;
                newState.count = action.payload.totalCount;
            } else {
                newState.purchaseInvoice = action.payload;
            }

            return newState;
            
        case Constants.FAILED_GET_PURCHASE_INVOICE:
            newState = {
                ...state,
                isLoading: false,
                isPosting: false,
                isPosted: false,
                error: action.error
            };

            return newState;

        case Constants.RESET_PURCHASE_INVOICE:
            newState = {
                ...state,
                purchaseInvoices: [],
                purchaseInvoice: null,
                filteredPurchaseInvoices: [],
                isLoading: false,
                isUpdating: false,
                isUpdated: false,
                isPosting: false,
                isPosted: false,
                count: 0,
                page: 1,
                pageSize: 10,
                error: null
            };
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/PurchaseInvoiceReducer.js